import { SelectionChangedEvent } from "ag-grid-community";
import { EquipmentCodeIndMappingEntity } from "domain/entity/EquipmentCodeIndMapping/EquipmentCodeIndMappingEntity";
import _ from "lodash";
import { INITIAL_EQUIPMENT_CODE_IND_MAPPING_COL_DEF } from "presentation/constant/EquipmentCodeIndMapping/EquipmentCodeIndMappingColumnDefinition";
import { EquipmentCodeIndMappingConstant } from "presentation/constant/EquipmentCodeIndMapping/EquipmentCodeIndMappingConstant";
import { useEquipmentCodeIndMappingVM } from "presentation/hook/EquipmentCodeIndMapping/useEquipmentCodeIndMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useEquipmentCodeIndMappingTracked } from "presentation/store/EquipmentCodeIndMapping/EquipmentCodeIndMappingProvider";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
const EquipmentCodeIndMappingTablePanel = () => {
    const gridRef: any = useRef(null);
    const [equipmentCodeIndMappingState] = useEquipmentCodeIndMappingTracked();
    // const {equipmentCodeIndMappingList,updatedRows} = equipmentCodeIndMappingState;
    const equipmentCodeIndMappingVM = useEquipmentCodeIndMappingVM();
    const messageBarVM = useMessageBarVM();
    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate, allowCreate } = anainfoState;
    const rightClickRef: any = createRef();
    // for right click menu with move after begin
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    const [allRows, setAllRows] = useState<EquipmentCodeIndMappingEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        // setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        equipmentCodeIndMappingVM.updateSelectedRows(selectedRows);
    }, [equipmentCodeIndMappingVM])


    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return equipmentCodeIndMappingState.selectedRows;
    }, [equipmentCodeIndMappingState.selectedRows]);

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);
    // //for right click menu with move after end

    // useEffect(() => {
    //     //const columnDefs = (INITIAL_EQUIPMENT_CODE_IND_MAPPING_COL_DEF?.slice());

    //     if (!equipmentCodeIndMappingState.selectedRows || equipmentCodeIndMappingState.selectedRows.length <= 0) {
    //         //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //         if (!onTableSelectionClicked) {
    //             gridRef.current?.gridRef.current.api?.deselectAll();
    //         }
    //     }
    //     changeCursor("equipment-code-ind-mapping-table", getShowMoveCursor());
    // });

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef?.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("equipment-code-ind-mapping-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked]);

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(equipmentCodeIndMappingState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [messageBarVM, rightClickRef, allowUpdate, equipmentCodeIndMappingState.selectedRows]);

    // const handleRowDrag = useCallback((e: any, updatedRows: EquipmentCodeIndMappingEntity[], movedIndex: number, overIndex: number)=>{
    //     equipmentCodeIndMappingVM.onRowDrag(updatedRows);
    // },[equipmentCodeIndMappingVM])


    // for right click menu with move after begin
    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        equipmentCodeIndMappingVM.updateSelectedRows([]);
        setShowMoveCursor(true);
    }, [equipmentCodeIndMappingVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(equipmentCodeIndMappingState.equipmentCodeIndMappingList);
        equipmentCodeIndMappingVM.updateSelectedRows([]);
        setShowMoveCursor(false);
    }, [equipmentCodeIndMappingState.equipmentCodeIndMappingList, equipmentCodeIndMappingVM]);

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        equipmentCodeIndMappingVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                equipmentCodeIndMappingVM.updateSelectedRows([]);
                setShowMoveCursor(false);
            } else {
                equipmentCodeIndMappingVM.searchAllEquipmentCodeIndMappingList().then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    equipmentCodeIndMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    equipmentCodeIndMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [messageBarVM, equipmentCodeIndMappingVM]);

    const handleRowDoubleClick = useCallback((entity: EquipmentCodeIndMappingEntity) => {
        // if(updatedRows.length > 0){
        //     messageBarVM.showError("Modified data has not been saved.Please save or refersh the data first."); 
        //     return;
        // }
        equipmentCodeIndMappingVM.onRowDoubleClick(entity);
    }, [equipmentCodeIndMappingVM])

    const handleAdd = useCallback(() => {
        equipmentCodeIndMappingVM.onAddClick();
    }, [equipmentCodeIndMappingVM]);

    const memoEquipmentCodeIndMappingTable = useMemo(() => {

        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" />}
                <div id="myDiv">
                    <NbisTable
                        id='equipment-code-ind-mapping-table'
                        isNewColumnSetting={true}
                        headerLabel={EquipmentCodeIndMappingConstant.Title.TITLE}
                        columns={INITIAL_EQUIPMENT_CODE_IND_MAPPING_COL_DEF}
                        data={allRows ?? []}
                        showPaginator={false}
                        editable={false}
                        showAddIcon={allowCreate}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: EquipmentCodeIndMappingEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 75px)"
                        ref={gridRef}
                        // isRowDrag={true}
                        // onRowDragged={handleRowDrag}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        // onBodyScroll={(e: any) => changeCursor("equipment-code-ind-mapping-table", getShowMoveCursor())}
                        onAddClick={handleAdd}
                        showCutCursor={showMoveCursor}
                    />
                </div>
            </>
        );
    }, [allowCreate, allRows, allowUpdate, getAllRows, getSelectedRows, handleRowDoubleClick, handleSelectionChange, onMoveCancel, onRefreshRow, onSaveMove, rightClickRef, showMoveCursor, handleAdd])

    useEffect(() => {
        if (initialAllRows && equipmentCodeIndMappingState.equipmentCodeIndMappingList && !_.isEmpty(equipmentCodeIndMappingState.equipmentCodeIndMappingList)) {
            setAllRows(equipmentCodeIndMappingState.equipmentCodeIndMappingList.map((equipmentCodeIndMappingEntity, index) => ({
                ...equipmentCodeIndMappingEntity,
                index: index || 0
            })));
            setInitialAllRows(false);
        }
    }, [allRows, initialAllRows, equipmentCodeIndMappingState.equipmentCodeIndMappingList]);

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoEquipmentCodeIndMappingTable}
        {equipmentCodeIndMappingState.forceRefresh && <></>}
    </TableWrapper>
    </>;
}

export default memo(EquipmentCodeIndMappingTablePanel);
